/**
 * ゲームモード
 *
 * プレイヤーが選択可能な対戦モードを定義する。
 */
export enum GameMode {
  /** 挑戦モード */
  CHALLENGE = 'CHALLENGE',
  /** 自由対戦（CPU） */
  FREE_CPU = 'FREE_CPU',
  /** 自由対戦（CPU）3vs3 */
  FREE_CPU_3V3 = 'FREE_CPU_3V3',
  /** フレンド対戦（部屋番号共有によるオンライン対戦） */
  FREE_LOCAL = 'FREE_LOCAL',
  /** オンライン対戦 */
  ONLINE = 'ONLINE',
  /** 観戦モード（CPU vs CPU） */
  SPECTATOR = 'SPECTATOR',
  /** サバイバルモード */
  SURVIVAL = 'SURVIVAL',
  /** 大会モード（総当たり） */
  TOURNAMENT_ROUND_ROBIN = 'TOURNAMENT_ROUND_ROBIN',
  /** 大会モード（トーナメント） */
  TOURNAMENT_ELIMINATION = 'TOURNAMENT_ELIMINATION',
}
